module.exports = __webpack_public_path__ + "img/resonances.02152cff.jpg";